import styled from 'styled-components';
import colors from 'theme/colors';

export const SelectWrapper = styled.div`
  .react-select__control {
    color: ${colors.white};
    background-color: hsl(var(--background));
    border: 1px solid hsl(var(--input));
  }

  .react-select__control:hover {
    border: 1px solid hsl(var(--input));
  }
`;
